import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generateDistroAdminFeeReport = async (data) => {
    const dateToday = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    });

    const docDefinition = {
        pageSize: 'LEGAL',
        pageOrientation: 'landscape',
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
        pageMargins: [40, 40, 40, 40],
        info: {
            title: `Client Summary for ${dateToday}.pdf`
        },
        content: [
            {
                table: {
                    body: [
                        [
                            { text: "Company Name", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Status", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Company ID", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Distro Account", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Agent Name (ID)", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Total Admin %", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Advisor Portion", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Split % of Advisor Portion", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: ">0 Max Admin Fee", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Active Employees", noWrap: true, fillColor: "#c2c0c0", bold: true },
                            { text: "Plan Admins", noWrap: true, fillColor: "#c2c0c0", bold: true }
                        ],
                        ...data.map(item => {
                            const advisorInfo = [
                                item.primaryAdvisor && item.advisor1Split
                                    ? { text: `${item.primaryAdvisor} (${item.advisor1Split}%)`, noWrap: true }
                                    : null,
                                item.advisor2Name && item.advisor2Split
                                    ? [
                                        { text: `${item.primaryAdvisor} (${100 - item.advisor2Split}%)`, noWrap: true },
                                        { text: `${item.advisor2Name} (${item.advisor2Split}%)`, noWrap: true }
                                    ]
                                    : null,
                                item.advisor3Name && item.advisor3Split
                                    ? { text: `${item.advisor3Name} (${item.advisor3Split}%)`, noWrap: true }
                                    : null
                            ].filter(Boolean);

                            const planAdminInfo = item.planAdmins.map(pa => [{ text: `${pa.firstName + " " + pa.lastName}`, noWrap: true }])

                            return [
                                { text: item.policyName },
                                item.enrollmentStatus,
                                { text: item.companyId, noWrap: true },
                                item.hcDistroId,
                                { text: `${item.primaryAdvisor} (${item.hcAdvisorId})`, noWrap: true },
                                { text: `${item.adminRate.toFixed(2)}`, alignment: 'right' },
                                { text: `${item.totalAdvisorSplitPercent.toFixed(2)}`, alignment: 'right' },
                                advisorInfo || '',
                                { text: item.isNonZeroMaxAdminFee.toString().toUpperCase() },
                                { text: `${item.employeeCount}`, alignment: 'right' },
                                planAdminInfo
                            ]
                        })
                    ]
                }
            },
        ],
        defaultStyle: {
            fontSize: 7,
        }
    };

    pdfMake.createPdf(docDefinition).open();
};

export const generateDistroAdminFeeCSV = (data) => {
    const dateToday = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    });

    const headers = [
        "Company Name",
        "Status",
        "Company ID",
        "Distro Account",
        "Agent Name (ID)",
        "Total Admin %",
        "Advisor Portion",
        "Split % of Advisor Portion",
        ">0 Max Admin Fee",
        "Active Employees",
        "Plan Admins"
    ];

    const rows = data.map(item => {
        const advisorInfo = [
            item.primaryAdvisor && item.advisor1Split
                ? `${item.primaryAdvisor} (${item.advisor1Split}%)`
                : null,
            item.advisor2Name && item.advisor2Split
                ? `${item.primaryAdvisor} (${100 - item.advisor2Split}%), ${item.advisor2Name} (${item.advisor2Split}%)`
                : null,
            item.advisor3Name && item.advisor3Split
                ? `${item.advisor3Name} (${item.advisor3Split}%)`
                : null
        ].filter(Boolean).join(" | ");

        const planAdmins = item.planAdmins
            .map(pa => `${pa.firstName} ${pa.lastName}`)
            .join(" | ");

        return [
            item.policyName,
            item.enrollmentStatus,
            item.companyId,
            item.hcDistroId,
            `${item.primaryAdvisor} (${item.hcAdvisorId})`,
            item.adminRate.toFixed(2),
            item.totalAdvisorSplitPercent.toFixed(2),
            advisorInfo,
            item.isNonZeroMaxAdminFee.toString().toUpperCase(),
            item.employeeCount,
            planAdmins
        ];
    });

    const csvContent = [
        headers.join(","),
        ...rows.map(r => r.map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Client Summary for ${dateToday}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
